import { NativeEvent } from '../NativeEvent';

export interface SharePayload {
  title?: string;
  message: string;
  url?: string;
}

/** Pede para o app abrir o share sheet nativo (Android/iOS). */
export class ShareEvent extends NativeEvent<'share', SharePayload> {
  readonly type = 'share';
  readonly payload: SharePayload;

  constructor(payload: SharePayload) {
    super();
    this.payload = payload;
  }

  protected override validate(): void {
    if (!this.payload.message) {
      throw new Error('ShareEvent: message é obrigatório');
    }
  }
}
